import type {
  Catalog,
  ConfiguratorConfig,
  Id,
  ModelOption,
  Product,
} from "@/configurator/domain/models/types";

export function findProduct(
  catalog: Catalog,
  productId: Id | undefined,
): Product | undefined {
  return catalog.products.find((product) => product.id === productId);
}

/** The product a freshly applied config starts on. */
export function getStartupProductId(catalog: Catalog): Id {
  return catalog.products[0]?.id ?? "default";
}

/**
 * The model the viewer should show: the selected one, else the configured
 * default, else the first the config ships. Resolved synchronously so the first
 * usable render does not wait for an effect.
 */
export function findActiveModelOption(
  config: ConfiguratorConfig,
  selectedModelId: Id | undefined,
): ModelOption | undefined {
  const { options, defaultModelId } = config.model;
  return (
    options.find((option) => option.id === selectedModelId) ??
    options.find((option) => option.id === defaultModelId) ??
    options[0]
  );
}
